module.exports = __webpack_public_path__ + "static/media/stock.25b5dc70.png";